import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Card, Col, Row, Spin, Typography, Button, Select, Modal, Upload, Input as AntInput, Button as AntButton, Icon, message, Divider, Checkbox } from 'antd';
import { fetchCenterBasicProfile, removeNetworkSpoc, changeCenterStatus, updateDiscountForAllSpecialists, uploadCSVDoctorDocument, fetchDoctorsDetailForCenterByCSV, uploadDoctorsDetailForCenterByCSV, createApporvalRequestForDiscountUpdate } from '../../services';
import { ButtonText } from "../../components/common/Text";
import { element } from 'prop-types';
import Papa from 'papaparse';
const { Paragraph, Title, Text } = Typography;

const { Option } = Select;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: column;
`;
let currentModal;

// const Row = styled.div`
//   display: flex;
//   flex-direction: row;
// `;

// const Col = styled.div`
//   display: flex;
//   flex: 1;
//   flex-direction: column;
//   margin-right: 10px;
// `;

class NetworkCenterSpecialistsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      centerSpecialists: [],
      applicableTariff: null,
      centerStatus: 'pending',
      fetchedSpecialists: [],
      offlineDiscountOperation: 'percentage',
      offlineDiscount: null,
      payoutOfflineDiscount: null,
      visitCommissionPercent: 0,
      offlinePayoutPercent: 100,
      enableVisitCommission: false,
      originalSpecialists: [],
      searchInput: '',
      fileList: [],
      fileDoctorDetailFileList: [],
      csvfile: null,
      doctorDetailsfileName: null,
      uploadButtonText: 'Choose File',
      uploadStatus: '',
      doctorsDetailFileUploadingStatus: null,
      uploadDoctorsDetaileCsvFile: null,
      doctorsFailedData: null,
      discountLoader:false,
    };
    console.log({ props });

    this.centerId = props.centerId;
  }

  componentDidMount = () => {
    this.fetchSpecialists();
  };

  fetchSpecialists = () => {
    this.setState({ loading: true });
    fetchCenterBasicProfile(this.centerId)
      .then(res => {
        console.log({ res },
          '[fetchCenterBasicProfile] response');
        const basicProfile = res;
        const { specialists } = basicProfile;
        const { centerDetails } = basicProfile;
        if(centerDetails){
          this.setState({
            applicableTariff : centerDetails.applicableTariff,
          });
        }
        if (specialists) {
          this.setState({
            centerSpecialists: specialists,
          });
        }
        if (basicProfile.centerDetails && basicProfile.centerDetails.centerStatus) {
          this.setState({
            centerStatus: basicProfile.centerDetails.centerStatus,
          });
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        const { centerSpecialists } = this.state;
        this.setState({ loading: false });
        this.setState({ originalSpecialists: centerSpecialists })
      });
  };

  openDoctorProfile = doctorId => () => {
    const { history } = this.props;
    history.push(`/doctor-profile/${doctorId}`);
  };

  handleChangeOnboardingStatus = (newStatus) => {
    Modal.confirm({
      title: 'Confirm Center Status',
      content: `Are you sure you want to change status to ${newStatus}?`,
      onOk: () => {
        return changeCenterStatus(this.centerId, newStatus)
          .then(this.fetchSpecialists);
      },
    });
  };

// Function to handle the modal display
handleDiscountChange = () => {
  const { offlineDiscount, payoutOfflineDiscount, offlineDiscountOperation, applicableTariff } = this.state;
  if (offlineDiscountOperation === 'percentage' && (Number(offlineDiscount) || 0) > 100) {
    message.error('Offline Discount cannot be greater than 100%');
    return;
  }
  if (offlineDiscountOperation === 'percentage' && (Number(payoutOfflineDiscount) || 0) > 100) {
    message.error('Visit Payout Discount cannot be greater than 100%');
    return;
  }
  if ((Number(offlineDiscount) || 0) > (Number(payoutOfflineDiscount) || 0)) {
    message.error('Offline Discount cannot be greater than Visit Payout Discount');
    return;
  }
  if (offlineDiscountOperation === 'fixed' && applicableTariff != null && Number(payoutOfflineDiscount) > Number(applicableTariff)) {
    message.error('Visit Payout Discount (fixed) cannot be greater than doctor charges');
    return;
  }
  Modal.confirm({
    title: (
      <div style={{ color: 'red', fontWeight: 'bold' }}>
        Warning: Discount Changes Detected
      </div>
    ),
    content: (
      <div>

        <hr style={{ border: '1px solid #f0f0f0', margin: '10px 0' }} />
        <p style={{ fontWeight: 'bold' }}>
          Changing discount will update the discount at centre level and it will
          go under approval process. Are you sure you want to proceed with the
          update?
        </p>
        <div
          style={{
            border: '1px solid red',
            padding: '10px',
            backgroundColor: '#fff5f5',
            marginTop: '10px',
          }}
        >
          <strong>Note:</strong> By continuing, you acknowledge and agree to the
          terms and conditions of Visit Health Pvt Ltd, including
          responsibilities related to mismanagement, penalties, and incorrect
          updates.
        </div>
        <hr style={{ border: '1px solid #f0f0f0', marginTop: '10px' }} />
      </div>
    ),
    icon: null, // No default icon to use custom styling
    okText: 'Continue',
    okType: 'primary',
    cancelText: 'Cancel',
    onOk: () => {
      return this.createApprovalRequestForDiscount();
    },
    onCancel: () => {},
    width: 600,
  });
};

handlePriceChangeForCsv = () => {
  Modal.confirm({
    title: (
      <div style={{ color: 'red', fontWeight: 'bold' }}>
        Warning: File may contain Price Related Changes
      </div>
    ),
    content: (
      <div>
        
        <hr style={{ border: '1px solid #f0f0f0', margin: '10px 0' }} />
        <p>
          This file may contain price-related changes and it will go under the approval process.
          Are you sure you want to proceed with the update?
        </p>
        <div
          style={{
            border: '1px solid red',
            padding: '10px',
            backgroundColor: '#fff5f5',
            marginTop: '10px',
          }}
        >
          <strong>Note:</strong> By continuing, you acknowledge and agree to the terms and conditions of Visit Health Pvt Ltd, including responsibilities related to mismanagement, penalties, and incorrect updates.
        </div>
        <hr style={{ border: '1px solid #f0f0f0', marginTop: '10px' }} />
      </div>
    ),
    icon: null, // No default icon to use custom styling
    okText: 'Continue',
    okType: 'primary',
    cancelText: 'Cancel',
    width: 600, // More rectangular shape // Optional: Adjust vertical position
    onOk: () => {
      console.log('Price change confirmed');
      this.handleDoctorDetailsUpload({
        file: this.state.uploadDoctorsDetaileCsvFile,
      });
    },
    onCancel: () => {
      console.log('Price change canceled');
      // Replace this with your cancellation logic
    },
  });
};


handleCsvFileStatus = (msg, apiStatus) => {
  const seconds = 3;

  if (currentModal) {
    currentModal.destroy();
  }

  switch (apiStatus) {
    case 'success':
      currentModal = Modal.success({
        title: msg || 'Operation completed successfully!',
      });
      break;
    case 'error':
      currentModal = Modal.error({
        title: msg || 'An error occurred during the operation.',
      });
      break;
    case 'warning':
      currentModal = Modal.warning({
        title: msg || 'This is a warning about the operation.',
      });
      break;
    case 'info':
      currentModal = Modal.info({
        title: msg || 'This is some information regarding the operation.',
      });
      break;
    default:
      currentModal = Modal.info({
        title: 'Unknown status',
      });
      break;
  }

  if (apiStatus === 'success' || apiStatus === 'failed') {
    setTimeout(() => {
      currentModal.destroy();
      currentModal = null; // Reset the modal reference after it's destroyed
    }, seconds * 1000);
  }
};

  onEnableVisitCommissionChange = (e) => {
    const checked = e.target.checked;
    const visitCommissionPercent = checked ? 70 : 0;
    const offlinePayoutPercent = checked ? 30 : 100;
    const newOfflineDiscount = Math.round((this.state.payoutOfflineDiscount || 0) * (offlinePayoutPercent / 100) * 100) / 100;
    this.setState({ enableVisitCommission: checked, visitCommissionPercent, offlinePayoutPercent, offlineDiscount: newOfflineDiscount });
  };

  onVisitCommissionPercentChange = (e) => {
    const val = Math.min(100, Math.max(0, Number.parseFloat(e.target.value) || 0));
    const offlinePayoutPercent = 100 - val;
    const newOfflineDiscount = Math.round((this.state.payoutOfflineDiscount || 0) * (offlinePayoutPercent / 100) * 100) / 100;
    this.setState({ visitCommissionPercent: val, offlinePayoutPercent, offlineDiscount: newOfflineDiscount });
  };

  createApprovalRequestForDiscount = () => {
    const { offlineDiscount, offlineDiscountOperation, payoutOfflineDiscount, visitCommissionPercent, offlinePayoutPercent } = this.state;
    const centerId = this.centerId;
    const discountPayload = {
      offlineDiscount,
      offlineDiscountOperation,
      payoutOfflineDiscount,
      visitCommissionPercent,
      offlinePayoutPercent,
      centerId
    };
    this.setState({
      discountLoader:true
    })
    createApporvalRequestForDiscountUpdate(discountPayload)
      .then((res) => {
        this.setState({ offlineDiscount: '', payoutOfflineDiscount: '' });
        this.setState({
          discountLoader:false
        })
        message.success('Request Created Successfully for Updating Discount', 4);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          discountLoader:false
        })
      })
  }

  searchHandler = (e) => {
    const value = e.target.value;
    this.setState({ searchInput: value });
    const { centerSpecialists } = this.state;
    console.log(`\nCurrent search value:${value}`);

    if (value.trim() === '') {
      this.setState({ originalSpecialists: centerSpecialists });
      return;
    }
    const pattern = new RegExp(value, 'gi');
    this.setState({
      originalSpecialists: centerSpecialists.filter((ele) => {
        // Search algo
        return ele.doctorName.match(pattern);
      })
    })
  }

  handleChange = ({ fileList }) => {
    console.log(fileList, "on change csv");
    this.setState({ fileList });
  };

  downloadDoctorDetail = () => {
    const centerId = this.centerId;

    console.log("centerId", centerId);

    fetchDoctorsDetailForCenterByCSV(centerId)
      .then((res) => {
        console.log(res);

        // Assuming `res.data` contains an array of doctor details
        if (res.data && res.data.length > 0) {
          const headers = Object.keys(res.data[0]).join(","); // Get headers from the keys of the first object

          const rows = res.data
            .map((doctor) =>
              Object.values(doctor)
                .map(value => {
                  // Handle null or undefined values by converting them to an empty string
                  if (value === null || value === undefined) {
                    return '';
                  }

                  // Convert value to string and handle potential issues with CSV format
                  const stringValue = String(value);

                  // If the value contains a comma, double-quote, or newline, it needs to be escaped
                  if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
                    // Escape double quotes by doubling them
                    return `"${stringValue.replace(/"/g, '""')}"`;
                  }

                  return stringValue;
                })
                .join(",")
            )
            .join("\n"); // Map each doctor's values to a CSV row

          const csvContent = `${headers}\n${rows}`; // Combine headers and rows

          // Create the CSV file
          const blob = new Blob([csvContent], { type: 'text/csv' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'doctors_detail.csv'; // Specify the filename
          a.click();
          URL.revokeObjectURL(url); // Clean up
        }
        this.handleCsvFileStatus("Doctor's details downloaded successfully", 'success');
      })
      .catch((err) => {
        console.log(err);
        this.setState({ uploadStatus: 'failed' });
        this.setState({ doctorsDetailFileUploadingStatus: 'failed' });

        this.handleCsvFileStatus("Failed to download doctor's details", 'error');
      })
      .finally(() => {
        this.setState({
          uploadStatus: '',
        });
      });
  };



  downloadFailedDataFile = () => {
    // Get the failed data from doctorsFailedData
    console.log("doctorsFailedData", this.state.doctorsFailedData);
    const failedData = this.state.doctorsFailedData;

    // Convert the JSON data into CSV format
    const csvData = Papa.unparse(failedData);

    // Create a Blob from the CSV string
    const blob = new Blob([csvData], { type: 'text/csv' });

    // Create a temporary download link
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'doctors_failed_data.csv'; // Specify the filename
    a.click();

    // Revoke the object URL to free up memory
    URL.revokeObjectURL(url);
  };


  // Function to handle file input changes
  handleDoctorDetailFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      this.setState({
        uploadDoctorsDetaileCsvFile: file,
        doctorDetailsfileName: file.name,
        uploadStatus: 'uploaded'
      });
      message.success(`${file.name} uploaded successfully. Details updation is in progress`);
    } else if (file.status === 'error') {
      this.setState({ uploadStatus: 'failed' });
      message.error(`${file.name} file upload failed.`);
    }
  };

  handleDoctorDetailsUpload = async ({ file }) => {
    try {
      console.log("File object before upload:", file);
      this.handleCsvFileStatus("Wait...", 'info');
      const isCSV = file.type === 'text/csv';
      if (!isCSV) {
        message.error('You can only upload CSV files!');
        return;
      }

      const res = await uploadDoctorsDetailForCenterByCSV(file, file.name, this.centerId);
      if (res.message === 'success') {
        this.setState({ uploadStatus: 'success', doctorsDetailFileUploadingStatus: 'success' });
        this.handleCsvFileStatus("Doctor's Details Uploaded Successfully", 'success');
        this.fetchSpecialists(this.centerId);
      } else if (res.message === 'faultedData') {
        this.setState({ uploadStatus: 'failed', doctorsDetailFileUploadingStatus: 'faultedData', doctorsFailedData: res.data });
        this.handleCsvFileStatus(res.errorMessage || "Some uploaded data is incorrect", 'error');
      } else {
        this.setState({ uploadStatus: 'failed', doctorsDetailFileUploadingStatus: 'failed', doctorsFailedData: res.data });
        this.handleCsvFileStatus("Something went wrong", 'error');
      }

    } catch (err) {
      this.setState({ uploadStatus: 'failed', doctorsDetailFileUploadingStatus: 'failed' });
      this.handleCsvFileStatus("Failed to upload doctor's details", 'error');
    }
  };

  handleRemove = (file) => {
    this.setState(prevState => ({
      fileDoctorDetailFileList: prevState.fileDoctorDetailFileList.filter(f => f.uid !== file.uid),
      doctorDetailsfileName: '',
      uploadStatus: ''
    }));
  };

  handleButtonClick = () => {
    const { uploadDoctorsDetaileCsvFile, uploadStatus } = this.state;
    if (uploadDoctorsDetaileCsvFile && uploadStatus !== 'uploading') {
      // this.handleDoctorDetailsUpload({
      //   file: this.state.uploadDoctorsDetaileCsvFile,
      // });
      this.handlePriceChangeForCsv();
    } else {
      // Open the file dialog
      this.uploadInput.click();
    }
  };

  // Ref to the hidden file input
  setUploadInputRef = (node) => {
    this.uploadInput = node;
  };

  handleUpload = (response) => {
    const { centerId } = this.props;
    const { documentCategory, mouLogIds } = this.state;
    this.setState({ csvfile: response.file })
    console.log(centerId, 'HandleUpload');
    console.log(response.file.uid, 'HandleUpload Response UID Check');
    return uploadCSVDoctorDocument(centerId, response.file, response.onProgress)
      .then((resInfo) => {
        console.log(resInfo, 'upload CSV Document response')

        response.onSuccess(response, response.file);
        message.success('Created doctor profiles');
        this.fetchSpecialists();
      })
      .catch((err) => {
        response.onError(err);
      });
  };

  
  render() {
    const { loading, centerSpecialists, centerStatus, offlineDiscountOperation, offlineDiscount, payoutOfflineDiscount, visitCommissionPercent, offlinePayoutPercent, enableVisitCommission, originalSpecialists, searchInput, fileList, doctorDetailsfileName, uploadButtonText, fileDoctorDetailFileList, uploadStatus, doctorsDetailFileUploadingStatus } = this.state;
    const { history } = this.props;
    const offlineDiscountType = (
      <Select
        value={offlineDiscountOperation}
        onChange={e => this.setState({ offlineDiscountOperation: e })}
      >
        <Option value="percentage">Percentage</Option>
        <Option value="fixed">Fixed Value</Option>
      </Select>
    );
    const payoutOfflineDiscountType = (
      <span
        style={{
          display: 'inline-block',
          padding: '0 11px',
          color: 'rgba(0, 0, 0, 0.65)',
        }}
      >
        {offlineDiscountOperation === 'fixed' ? 'Fixed Value' : 'Percentage'}
      </span>
    );
    const getStatusStyles = (status) => {
      switch (status || 'pending') {
        case 'pending':
          return { color: '#ffb703' };
        case 'live':
          return { color: '#02bf6a', };
        case 'not-live':
          return { color: '#f77d0a', };
        default:
          return { color: 'black', };
      }
    };
    const getStatusText = (status) => {
      switch (status || 'pending') {
        case 'pending':
          return 'Pending';
        case 'live':
          return 'Live';
        case 'not-live':
          return 'Not Live';
        default:
          return '';
      }
    };
    const renderSpecialist = (ele, idx) => {
      return (
        <Col key={idx} xs={24} md={12}>
          <Card style={{ height: '100%' }} bodyStyle={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <EduRowComponent>
              <Row type="flex" align="middle" justify="space-between" gutter={[8, 8]}>
                <Col style={{ flex: 1, minWidth: 0 }}>
                  <Title level={4} style={{ margin: 0 }} ellipsis={{ rows: 1 }}>
                    {ele.doctorName}
                  </Title>
                </Col>
                {ele.status && (
                  <Col style={{ display: 'flex', alignItems: 'center' }}>
                    <span
                      style={{
                        height: '10px',
                        width: '10px',
                        borderRadius: '50%',
                        display: 'inline-block',
                        marginRight: '5px',
                        backgroundColor: getStatusStyles(ele.status).color,
                      }}
                    ></span>
                    <strong style={{ margin: 0, color: getStatusStyles(ele.status).color }}>
                      {getStatusText(ele.status)}
                    </strong>
                  </Col>
                )}
              </Row>

              <Paragraph strong style={{ margin: '8px 0 0' }}>
                {ele.vertical}
              </Paragraph>
              <Paragraph type="secondary" style={{ margin: 0 }}>
                {ele.qualifications}
              </Paragraph>

              <Divider style={{ margin: '12px 0' }} />

              <Row gutter={[16, 8]}>
                <Col xs={24} sm={12}>
                  <div style={{ color: 'rgba(0,0,0,0.45)', fontSize: 12 }}>Fee</div>
                  <div style={{ fontWeight: 600 }}>{`${ele.fee} ₹`}</div>
                </Col>
                <Col xs={24} sm={12}>
                  <div style={{ color: 'rgba(0,0,0,0.45)', fontSize: 12 }}>Offline Discount</div>
                  <div style={{ fontWeight: 600 }}>
                    {ele.offlineDiscountOperation === 'percentage' ? `${ele.offlineDiscount} %` : `Rs. ${ele.offlineDiscount}`}
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div style={{ color: 'rgba(0,0,0,0.45)', fontSize: 12 }}>Visit Payout Discount</div>
                  <div style={{ fontWeight: 600 }}>
                    {ele.offlineDiscountOperation === 'percentage' ? `${Number(ele.payoutOfflineDiscount) || 0} %` : `Rs. ${Number(ele.payoutOfflineDiscount) || 0}`}
                  </div>
                </Col>
              </Row>

              <Divider style={{ margin: '12px 0' }} />

              <Button
                icon="edit"
                onClick={this.openDoctorProfile(ele.doctorId)}
                style={{ alignSelf: 'flex-start' }}
              >
                Doctor Profile
              </Button>
            </EduRowComponent>
          </Card>
        </Col>
      );
    };
    return (
      <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ marginBottom: '20px' }}>
          <Title level={2} style={{ marginBottom: 4 }}>Center Specialists</Title>
          {!loading && (
            <Text type="secondary">{`Number of Specialists: ${centerSpecialists.length}`}</Text>
          )}
        </div>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '80px 0' }}>
            <Spin size="large" />
          </div>
        ) : (
          <React.Fragment>
            {/* Center configuration */}
            <Card title="Center Configuration" style={{ marginBottom: 16 }}>
              <Row gutter={[16, 16]} type="flex" align="middle">
                <Col xs={24} md={12} lg={8}>
                  <div style={{ fontWeight: 600, marginBottom: 8 }}>On-boarding Status</div>
                  <Select
                    style={{ width: '100%' }}
                    onSelect={e => {
                      this.handleChangeOnboardingStatus(e);
                    }}
                    value={centerStatus}
                  >
                    <Option value="pending">Pending</Option>
                    <Option value="not-live">Not Live</Option>
                    <Option value="live">Live</Option>
                  </Select>
                </Col>
                {this.state.applicableTariff && (
                  <Col xs={24} md={12} lg={8}>
                    <div style={{ fontWeight: 600, marginBottom: 8 }}>Doctor Tariff</div>
                    <span style={{ fontWeight: 600, color: '#1890ff' }}>
                      {this.state.applicableTariff}
                    </span>
                  </Col>
                )}
              </Row>
            </Card>

            {/* Document management */}
            <Card title="Document Management" style={{ marginBottom: 16 }}>
              <Row gutter={[24, 24]}>
                <Col xs={24} md={12}>
                  <div style={{ fontWeight: 600, marginBottom: 8 }}>Upload doctors list (CSV only)</div>
                  <Upload
                    accept=".csv"
                    fileList={fileList}
                    onChange={this.handleChange}
                    onRemove={this.handleRemove}
                    beforeUpload={this.beforeUpload}
                    customRequest={this.handleUpload}
                  >
                    <AntButton>
                      <Icon type="upload" /> Upload
                    </AntButton>
                  </Upload>
                  <div style={{ marginTop: 8 }}>
                    <a href='https://visit-public.s3.ap-south-1.amazonaws.com/Doctors-Upload-Template.csv' download='testDataDoctors' target="_blank"> download sample file </a>
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div style={{ border: '1px solid #EBEAF5', padding: '16px', borderRadius: '5px' }}>
                    <Text
                      onClick={this.downloadDoctorDetail}
                      style={{ cursor: 'pointer', color: '#714FFF', textDecoration: 'underline' }}
                    >
                      Download Doctor Detail
                    </Text>
                    <Row type="flex" align="middle" justify="space-between" gutter={[12, 12]} style={{ marginTop: '16px' }}>
                      <Col>
                        <Text style={{ color: '#0F0B28' }}>Update doctor's details</Text>
                      </Col>
                      <Col>
                        <Text style={{
                          color: uploadStatus === 'uploading' ? '#ffe58f' : '#714FFF',
                        }}>{doctorDetailsfileName}</Text>
                      </Col>
                      <Col>
                        <input
                          type="file"
                          accept=".csv"
                          style={{ display: 'none' }}
                          ref={this.setUploadInputRef}
                          onChange={(e) => this.handleDoctorDetailFileChange(e)}
                        />
                        <Button
                          type="primary"
                          onClick={this.handleButtonClick}
                          style={{
                            backgroundColor: '#ffffff',
                            borderColor: uploadStatus === 'uploading' ? '#ffe58f' : '#714FFF',
                            color: uploadStatus === 'uploading' ? '#ffe58f' : '#714FFF',
                          }}
                        >
                          {uploadStatus === 'uploading' ? 'Uploading...' : (this.state.uploadDoctorsDetaileCsvFile ? 'Upload File' : 'Choose File')}
                        </Button>
                      </Col>
                    </Row>
                    {doctorsDetailFileUploadingStatus && (
                      <Row style={{ marginTop: '12px' }}>
                        <Col span={24}>
                          <Text
                            // Conditionally set the onClick handler only if status is 'failed'
                            onClick={doctorsDetailFileUploadingStatus == 'faultedData' ? this.downloadFailedDataFile : null}
                            style={{
                              cursor: doctorsDetailFileUploadingStatus == 'faultedData' ? 'pointer' : 'default', // Pointer if clickable
                              textDecoration: doctorsDetailFileUploadingStatus == 'faultedData' ? 'underline' : '',
                              color: doctorsDetailFileUploadingStatus == 'success' ? '#56AE3D' : '#F5BF7F',
                              fontWeight: 'bold'
                            }}
                          >
                            {doctorsDetailFileUploadingStatus == 'success'
                              ? 'Successfull'
                              : doctorsDetailFileUploadingStatus == 'faultedData' ? 'Download Failed Data' : ''}
                          </Text>
                        </Col>
                      </Row>
                    )}
                  </div>
                </Col>
              </Row>
            </Card>

            {/* Discount approval */}
            <Card title="Discount Approval" style={{ marginBottom: 16 }}>
              <div
                style={{
                  background: 'linear-gradient(135deg, #f9f7ff 0%, #fffbf0 100%)',
                  border: '1px solid #d3c8f5',
                  borderRadius: 10,
                  padding: '16px 18px 14px',
                  marginBottom: 16,
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14, borderBottom: '1px solid #e3deff', paddingBottom: 10 }}>
                  <span style={{ fontWeight: 700, fontSize: 13, color: '#5a3fc0' }}>Payout Configuration</span>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <Checkbox checked={enableVisitCommission} onChange={this.onEnableVisitCommissionChange}>
                      <span style={{ fontSize: 12 }}>Set Visit Commission (default 70/30)</span>
                    </Checkbox>
                    <div
                      style={{
                        background: visitCommissionPercent + offlinePayoutPercent === 100 ? '#f6ffed' : '#fff1f0',
                        border: `1px solid ${visitCommissionPercent + offlinePayoutPercent === 100 ? '#b7eb8f' : '#ffa39e'}`,
                        borderRadius: 20, padding: '2px 12px', fontSize: 12, fontWeight: 600,
                        color: visitCommissionPercent + offlinePayoutPercent === 100 ? '#52c41a' : '#f5222d',
                      }}
                    >
                      {visitCommissionPercent}% + {offlinePayoutPercent}% = {visitCommissionPercent + offlinePayoutPercent}%
                    </div>
                  </div>
                </div>

                <Row gutter={[12, 12]}>
                  {/* Visit Payout Discount — has the dropdown */}
                  <Col xs={24} md={12}>
                    <div style={{ background: '#fff', border: '1px solid #d3c8f5', borderRadius: 8, padding: '12px 14px' }}>
                      <div style={{ fontSize: 11, fontWeight: 600, color: '#5a3fc0', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Visit Payout Discount</div>
                      <AntInput
                        style={{ width: '100%' }}
                        value={payoutOfflineDiscount}
                        addonBefore={offlineDiscountType}
                        onChange={(e) => {
                          const val = Number.parseFloat(e.target.value) || 0;
                          if (offlineDiscountOperation === 'percentage' && val > 100) {
                            message.error('Percentage value cannot be greater than 100%');
                            return;
                          }
                          const newOfflineDiscount = Math.round(val * (offlinePayoutPercent / 100) * 100) / 100;
                          this.setState({ payoutOfflineDiscount: val, offlineDiscount: newOfflineDiscount });
                        }}
                        placeholder="0"
                      />
                      <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 5 }}>Discount taken from the partner center</div>
                    </div>
                  </Col>

                  {/* Offline Discount — auto-calculated, disabled */}
                  <Col xs={24} md={12}>
                    <div style={{ background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 8, padding: '12px 14px' }}>
                      <div style={{ fontSize: 11, fontWeight: 600, color: '#d48806', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Offline Discount (User Discount)</div>
                      <AntInput
                        style={{ width: '100%' }}
                        value={offlineDiscount}
                        addonBefore={payoutOfflineDiscountType}
                        disabled
                        placeholder="0"
                      />
                      <div style={{ fontSize: 11, color: '#d48806', marginTop: 5 }}>Auto-calculated · Discount given to the patient</div>
                    </div>
                  </Col>

                  {/* Visit Commission % */}
                  <Col xs={24} md={12}>
                    <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 8, padding: '12px 14px' }}>
                      <div style={{ fontSize: 11, fontWeight: 600, color: '#389e0d', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Visit Commission %</div>
                      <AntInput
                        style={{ width: '100%' }}
                        value={visitCommissionPercent}
                        addonAfter="%"
                        disabled={!enableVisitCommission}
                        onChange={this.onVisitCommissionPercentChange}
                        placeholder="70"
                      />
                      <div style={{ fontSize: 11, color: '#52c41a', marginTop: 5 }}>This is the Visit Commission</div>
                    </div>
                  </Col>

                  {/* User Discount % */}
                  <Col xs={24} md={12}>
                    <div style={{ background: '#fff0f6', border: '1px solid #ffadd2', borderRadius: 8, padding: '12px 14px' }}>
                      <div style={{ fontSize: 11, fontWeight: 600, color: '#c41d7f', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px' }}>User Discount %</div>
                      <AntInput
                        style={{ width: '100%' }}
                        value={offlinePayoutPercent}
                        addonAfter="%"
                        disabled
                        placeholder="30"
                      />
                      <div style={{ fontSize: 11, color: '#eb2f96', marginTop: 5 }}>This is the Offline / User Discount</div>
                    </div>
                  </Col>
                </Row>
              </div>

              <Button
                style={{ background: 'red', border: '1px solid red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 8, fontWeight: 600 }}
                type="primary"
                size="large"
                onClick={this.handleDiscountChange}
                disabled={this.state.payoutOfflineDiscount == null || this.state.discountLoader}
              >
                {this.state.discountLoader && <Spin style={{ paddingRight: '10px' }} size="small" />}
                <ButtonText>Send Approval Request</ButtonText>
              </Button>
            </Card>

            {/* Search */}
            <Card style={{ marginBottom: 16 }} bodyStyle={{ padding: '16px' }}>
              <Row gutter={[16, 16]} type="flex" align="middle">
                <Col xs={24} md={6}>
                  <label style={{ fontWeight: 600 }}>Search Specialists</label>
                </Col>
                <Col xs={24} md={18}>
                  <AntInput
                    style={{ width: '100%' }}
                    placeholder="Specialist name"
                    value={searchInput}
                    onChange={this.searchHandler}
                    prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,0.25)' }} />}
                  />
                </Col>
              </Row>
            </Card>

            {/* Specialist list */}
            <Row gutter={[16, 16]}>
              {originalSpecialists.map(renderSpecialist)}
            </Row>
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authToken: state.user.authToken,
});

export default withRouter(
  connect(mapStateToProps)(NetworkCenterSpecialistsScreen)
);
